import { Translations } from './translation-interface';
import { appTranslationsES } from '../../i18n';
import { loginTranslationsES } from '../../pages/anonymous/Login/i18n';
import { assessmentResultTranslationsES } from '../../pages/shared/AssessmentResult/i18n';
import { assessmentTranslationsES } from '../../pages/shared/assessments/i18n';
import { patientAssessmentCardTranslationsES } from '../../global_elements/Layouts/Cards/PatientAssessmentCard/i18n';
import { patientDashboardTranslationsES } from '../../pages/patient/PatientDashboard/i18n';
import { resourcesTranslationsES } from '../../pages/patient/PatientResources/i18n';
import { helpTranslationsES } from '../../pages/shared/Help/i18n';
import { daisyChainTranslationsES } from '../../pages/shared/DaisyChainAssessments/i18n';
import { patientConsentTranslationsES } from '../../pages/patient/PatientConsent/i18n';
import { patientAccountTranslationsES } from '../../pages/patient/PatientAccount/i18n';
import { accountDeleteConfirmTranslationsES } from '../../pages/anonymous/AccountDeleteConfirm/i18n';
import { assessmentVerifyTranslationsES } from '../../pages/anonymous/Assessment/AssessmentVerify.i18n';
import { datePickerTranslationsES } from '../../global_elements/Inputs/LabeledDatePickerInput/i18n';
import { assessmentFormTranslationsES } from '../../pages/anonymous/Assessment/AssessmentForm.i18n';
import { anonymousAssessmentTranslationsES } from '../../pages/anonymous/Assessment/index.i18n';

export const es: Translations = {
  app: appTranslationsES,
  login: loginTranslationsES,
  assessmentResult: assessmentResultTranslationsES,
  assessment: assessmentTranslationsES,
  patientAssessmentCard: patientAssessmentCardTranslationsES,
  patientDashboard: patientDashboardTranslationsES,
  resources: resourcesTranslationsES,
  help: helpTranslationsES,
  daisyChain: daisyChainTranslationsES,
  patientConsent: patientConsentTranslationsES,
  patientAccount: patientAccountTranslationsES,
  accountDeleteConfirm: accountDeleteConfirmTranslationsES,
  assessmentVerify: assessmentVerifyTranslationsES,
  datePicker: datePickerTranslationsES,
  assessmentForm: assessmentFormTranslationsES,
  anonymousAssessment: anonymousAssessmentTranslationsES,
};
